import { render, staticRenderFns } from "./EditReservationWidgetForm.vue?vue&type=template&id=1a4a958e&scoped=true"
import script from "./EditReservationWidgetForm.vue?vue&type=script&lang=js"
export * from "./EditReservationWidgetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4a958e",
  null
  
)

export default component.exports